import React, { useState, useEffect } from 'react';
import { Shield, Lock, ArrowRight } from 'lucide-react';
import AdminPanelDesktop from './AdminPanelDesktop';
import AdminPanelMobile from './AdminPanelMobile';

export default function AdminPanel() {
  const [isAuthenticated, setIsAuthenticated] = useState(() => {
    return sessionStorage.getItem('doisplay_admin_auth') === 'true';
  });
  const [password, setPassword] = useState('');
  const [error, setError] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Puxa a senha do arquivo .env com fallback de segurança caso falte
  const ADMIN_PASSWORD = 'admin123123';

  const handleLogin = (e: React.FormEvent) => {
    e.preventDefault();
    if (password === ADMIN_PASSWORD) {
      setIsAuthenticated(true);
      sessionStorage.setItem('doisplay_admin_auth', 'true');
      setError(false);
    } else {
      setError(true);
    }
  };

  const handleLogout = () => {
    sessionStorage.removeItem('doisplay_admin_auth');
    setIsAuthenticated(false);
  };

  // Tela de Login
  if (!isAuthenticated) {
    return (
      <div style={{
        backgroundColor: '#000000', color: '#fff', minHeight: '100vh',
        display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: 'system-ui, sans-serif', padding: '20px'
      }}>
        <div style={{
          backgroundColor: '#141414', padding: '30px', borderRadius: '8px',
          width: '100%', maxWidth: '380px', border: '1px solid #333', textAlign: 'center',
          boxShadow: '0 10px 30px rgba(0,0,0,0.8)'
        }}>
          <div style={{ 
            width: '55px', height: '55px', backgroundColor: 'rgba(229,9,20,0.1)', 
            borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', 
            margin: '0 auto 16px auto', border: '1px solid rgba(229,9,20,0.3)' 
          }}>
            <Shield size={26} color="#E50914" />
          </div>

          <h1 style={{ fontSize: '20px', fontWeight: '900', margin: '0 0 6px 0', letterSpacing: '1px' }}>
            DOIS<span style={{ color: '#E50914' }}>PLAY</span>
          </h1>
          <p style={{ fontSize: '12px', color: '#888', margin: '0 0 20px 0' }}>Área Restrita de Administração</p>

          <form onSubmit={handleLogin} style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
            <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
              <Lock size={16} color="#666" style={{ position: 'absolute', left: '12px' }} />
              <input 
                type="password"
                placeholder="Senha de acesso"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                style={{
                  width: '100%', backgroundColor: '#0a0a0a', border: error ? '1px solid #E50914' : '1px solid #333',
                  borderRadius: '4px', padding: '10px 10px 10px 38px', color: '#fff', fontSize: '13px', outline: 'none',
                  boxSizing: 'border-box'
                }}
              />
            </div>

            {error && (
              <span style={{ color: '#E50914', fontSize: '11px', textAlign: 'left' }}>
                Senha incorreta.
              </span>
            )}

            <button 
              type="submit"
              style={{
                display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '6px',
                backgroundColor: '#E50914', color: '#fff', border: 'none', padding: '10px',
                borderRadius: '4px', fontSize: '13px', fontWeight: 'bold', cursor: 'pointer'
              }}
            >
              Entrar <ArrowRight size={14} />
            </button>
          </form>
        </div>
      </div>
    );
  }

  // Carrega automaticamente o arquivo correto dependendo de onde está acessando
  return isMobile ? <AdminPanelMobile onLogout={handleLogout} /> : <AdminPanelDesktop onLogout={handleLogout} />;
}